/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, TextField } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, getFormValues, Field } from 'redux-form';
import { isMobile } from 'react-device-detect';
import axios from 'axios';
import { BASE_API, USER_TOKEN } from 'config/consts';

import PrimaryButton from 'common/components/buttons/primaryButton';
import SecondaryButton from 'common/components/buttons/secondaryButton';
import GenericConfirmationCard from 'common/components/cards/genericConfirmationModel/genericConfirmationModel';
import LoadingProgress from 'common/components/progress/loading';
import { SelectLabel } from 'common/components/fields/SelectLabel';
import { EditorConvertToHTMLActivity } from 'common/components/fields/EditorConvertToHTMLActivity';
import { FORM_RULES } from 'helpers/validations';
import { getList as getCategoriesList } from '../../../categories/categoriesActions';

const Interaction = props => {
  const [redesList, setRedesList] = useState([]);

  useEffect(() => {
    props.getCategoriesList();
    loadRedes();
  }, []);

  const loadRedes = async () => {
    try {
      const response = await axios.get(`${BASE_API}/tanque-cheio/redes`, {
        headers: {
          Authorization: `${JSON.parse(localStorage.getItem(USER_TOKEN))}`,
        },
      });
      
      const redes = response.data.map(rede => ({
        value: rede.id,
        label: rede.nome,
      }));
      
      setRedesList(redes);
    } catch (error) {
      console.error('Erro ao carregar redes:', error);
    }
  };

  const onSubmit = values => {
    console.log('Props disponíveis:', Object.keys(props));
    
    if (!values.has_product_order_parameter) {
      values.product_order_parameter_title = null;
      values.product_order_parameter_subtitle = null;
    }
    values.categories = values.categories_field ? values.categories_field.map(i => i.id) : [];
    values.groupings = values.groupings_field ? values.groupings_field.map(i => i.id) : [];
    values.submitFromButton = true;
    
    // Navega para próxima aba
    if (props.handleNativeChange) {
      const currentValue = props.value || 1;
      const nextValue = currentValue + 1;
      props.handleNativeChange(null, nextValue);
    }
  };

  const act = props.formValues || {};
  const now = new Date();
  const disabled = act.is_tanque_cheio ? false : (!act.is_draft && now > new Date(act.end));

  if (props.coupons.loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: 50 }}>
        <LoadingProgress />
      </div>
    );
  }

  return (
    <form onSubmit={props.handleSubmit(onSubmit)} noValidate>
      <div
        style={{
          overflowY: 'auto',
          height: isMobile ? 'calc(100vh - 200px)' : 'calc(100vh - 350px)',
          paddingRight: isMobile ? 0 : 15,
        }}
      >
        <Box mb={3}>
          <Field
            name="voucher_expiration"
            component={({ input, meta }) => (
              <TextField
                label="Data de Expiração do Voucher"
                type="datetime-local"
                fullWidth
                InputLabelProps={{ shrink: true }}
                error={meta.touched && Boolean(meta.error)}
                helperText={meta.touched ? meta.error : ''}
                {...input}
              />
            )}
            validate={[FORM_RULES.required]}
          />
        </Box>

        {/*** 2) Dropdowns em sequência ***/}
        <Box mb={2}>
          <Field
            name="tipo_combustivel"
            component={SelectLabel}
            label="Tipo de Combustível"
            options={[
              { value: 'etanol', label: 'Etanol' },
              { value: 'gasolina_comum', label: 'Gasolina Comum' },
              { value: 'gasolina_aditivada', label: 'Gasolina Aditivada' },
              { value: 'podium', label: 'Gasolina Podium' },
              { value: 'diesel', label: 'Diesel' },
              { value: 'diesel_s10', label: 'Diesel S10' },
            ]}
            validate={[FORM_RULES.required]}
            disabled={disabled}
          />
        </Box>

        <Box mb={3}>
          <Field
            name="rede_id"
            component={SelectLabel}
            label="Rede de Postos"
            options={redesList}
            validate={[FORM_RULES.required]}
            disabled={disabled}
          />
        </Box>

        <Box mb={4}>
          <Typography
            variant="subtitle2"
            style={{ fontSize: 16, fontWeight: 400, marginBottom: 8 }}
          >
            Regulamento do Voucher
          </Typography>

          <Field
            name="voucher_regulation"
            component={EditorConvertToHTMLActivity}
            showAddImageButton={false}
            toolbar={{
              options: ['inline', 'blockType', 'list', 'history'],
              inline: { options: ['bold', 'italic', 'strikethrough'] },
              blockType: {
                options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6'],
              },
              list: { options: ['unordered', 'ordered'] },
              history: { options: ['undo', 'redo'] },
            }}
            validate={[FORM_RULES.required]}
            disabled={disabled}
          />
        </Box>

        <GenericConfirmationCard
          open={props.openConfirmation}
          cancelClose={props.handleCancelClose}
          labelLeftButton="Continuar aqui"
          labelRightButton={props.buttonConfirmationLabel}
          general={props.general}
          title={props.confirmationTitle}
          text={props.confirmationSubtitle}
          confirmButtonColor="primary"
          onClose={() => props.setOpenConfirmation(false)}
          onClick={props.closeModal}
        />
      </div>

      <Box display="flex" justifyContent="space-between" mt={2}>
        <SecondaryButton
          type="button"
          onClick={props.prevClick}
          style={{ width: '48%', textTransform: 'none' }}
        >
          Voltar
        </SecondaryButton>
        <PrimaryButton
          type="submit"
          color="primary"
          disabled={
            props.activeActions.buttonLoading ||
            !props.valid ||
            disabled
          }
          style={{ width: '48%', textTransform: 'none' }}
        >
          Salvar e continuar
        </PrimaryButton>
      </Box>
    </form>
  );
};

Interaction.propTypes = {
  activeActions: PropTypes.shape({ buttonLoading: PropTypes.bool }).isRequired,
  buttonConfirmationLabel: PropTypes.string,
  closeModal: PropTypes.func.isRequired,
  confirmationSubtitle: PropTypes.string,
  confirmationTitle: PropTypes.string,
  coupons: PropTypes.shape({ loading: PropTypes.bool }).isRequired,
  formValues: PropTypes.shape({
    products:           PropTypes.array,
    questions:          PropTypes.array,
    delivery_locations: PropTypes.array,
    digital_product:    PropTypes.bool,
    has_product_order_parameter: PropTypes.bool,
    partner_id:         PropTypes.any,
    comission_owner_percentage: PropTypes.any,
    type_id:            PropTypes.number,
    is_draft:           PropTypes.bool,
    end:                PropTypes.string,
  }).isRequired,
  general:                PropTypes.any,
  handleCancelClose:      PropTypes.func.isRequired,
  handleSubmit:           PropTypes.func.isRequired,
  onClickProgress:        PropTypes.func.isRequired,
  openConfirmation:       PropTypes.bool.isRequired,
  prevClick:              PropTypes.func.isRequired,
  categories:             PropTypes.array.isRequired,
  postosList:             PropTypes.array.isRequired,
  setOpenConfirmation:    PropTypes.func.isRequired,
  getCategoriesList:      PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  const catState    = state.categories || {};
  const postosState = state.postos     || {};
  const categories  = Array.isArray(catState.list)    ? catState.list    : [];
  const postosList  = Array.isArray(postosState.list) ? postosState.list : [];
  const fv = getFormValues('tanqueCheioForm')(state) || {};

  return {
    coupons:        state.coupons,
    categories,
    postosList,
    activeActions:  state.activeActions,
    general:        state.general,
    formValues: {
      products:           fv.products           || [],
      questions:          fv.questions          || [],
      delivery_locations: fv.delivery_locations || [],
      ...fv,
    },
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getCategoriesList,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'tanqueCheioForm',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  })(Interaction)
);
